import React, { useEffect, useState, Fragment } from "react"
import { Link, useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Select, { components } from 'react-select'

import { httpOk, GET, POST, PUT, DELETE, FILE } from 'helpers/api'
import { formatDate, uploadUrl } from "helpers/helpers"
import DeleteModal from "pages/parts/DeleteModal"
import { toast } from "react-toastify"

function CreateUpdate() {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()

  const [data, setData] = useState({
    'name': '',
    'category_id': '',
    'product_type': 1,
    'unit_id': 1,
    'status': 1,
    'write_off_type': 1,
    'description': '',
    'quantity': '',
    'sale_price': '',
    'barcode': '',
    'fiscal_code': '',
    'fiscal_package_code': '',
    'code': '',
    'tax_category_id': '',
  })
  const [categories, setCategories] = useState([])
  const [productTypes, setProductTypes] = useState([])
  const [ingredients, setIngredients] = useState([])
  const [categoriesInitial, setCategoriesInitial] = useState([])
  const [units, setUnits] = useState([])
  const [activeTab, setActiveTab] = useState(1)
  const [mainActiveTab, setMainActiveTab] = useState(1)
  const [isOpen, setIsOpen] = useState(false)
  const [modalDeleteIngredient, setModalDeleteIngredient] = useState(false)
  const [deleteModalIngredientParams, setDeleteModalIngredientParams] = useState({ 'id': 0, 'index': 0 })

  async function createUpdate(e, saveContinue = false) {
    e.preventDefault()

    var sendData = { ...data }
    sendData.ingredients = data.ingredients
    sendData.prices = data.prices
    sendData.error = false

    if (sendData?.sizes?.length > 0) { // Если есть размеры цены обязательные
      for (let i = 0; i < sendData?.sizes.length; i++) {
        if (sendData?.sizes[i]['price'] === '' || sendData?.sizes[i]['sale_price'] === '') {
          sendData.error = true
        }
      }
    }

    if (sendData?.modifiers?.length > 0) { // Если есть модификаторы
      sendData.bool_modifiers = 1
    }

    if (data.product_type === 2) { // Если это заготовка
      sendData.quantity = 1
    }

    var response;
    if (sendData.id) {
      response = await PUT('/products', sendData, { loader: true })
    } else {
      response = await POST('/products', sendData, { loader: true })
    }

    if (httpOk(response)) {
      if (!saveContinue) {
        navigate('/products')
      } else {
        setData({
          ...data,
          'name': '',
          'sale_price': '',
          'product_type': 1,
          'unit_id': 1,
          'status': 1,
          'write_off_type': 1,
          'description': '',
          'image': '',
          'cooking_time': '',
          'showSmiles': false,
          'sizes': [],
          'ingredients': [],
        })
      }
    }
  }

  function addIngredients() {
    // if (elements.length === 0) {
    // 	toast.error('Произведите приход')
    // 	return
    // }

    var dataCopy = { ...data }
    var ingredient = {
      'element_id': null,
      'name': '',
      'unit_id': '',
      'unit_name': '',
      'second_unit_id': '',
      'price': '',
      'quantity': '',
      'loss': '',
      'product_type': '',
      'units': [],
    }
    if (!dataCopy.ingredients) {
      dataCopy.ingredients = [];
    }
    if (dataCopy.ingredients) {
      dataCopy.ingredients.push(ingredient)
      setData(dataCopy)
    }
  }

  function handleChangeIngridientSelect(index, value) {
    var dataCopy = { ...data }

    dataCopy.ingredients[index] = value;

    setData(dataCopy)
  }


  function handleSelectInProduct(option) {
    setData({
      ...data,
      'product_type': option.id,
      'price': option.id === 2 ? 0 : '',
      'sale_price': option.id === 2 ? 0 : '',
      'menu_id': '',
    })
  }

  function handleIngridientChange(e, index) {
    var dataCopy = { ...data }

    if (e.target.type === 'number' || e.target.type === 'text') {
      dataCopy.ingredients[index][e.target.name] = e.target.value
    }

    if (e.target.name === 'quantity') {
      calculateCostPrice(dataCopy)
    } else {
      setData(dataCopy)
    }
  }

  function toggleModalDeleteIngredient(item, index) {
    if (item.id) {
      setDeleteModalIngredientParams({ 'id': item.id, 'index': index })
      setModalDeleteIngredient(true)
    } else {
      var dataCopy = { ...data }
      dataCopy.ingredients.splice(index, 1)

      calculateCostPrice(dataCopy)
    }
  }

  async function deleteIngredient() {
    await DELETE(`/products-ingredient/${deleteModalIngredientParams.id}`, {}, { loader: true })
    var dataCopy = { ...data }
    dataCopy.ingredients.splice(deleteModalIngredientParams.index, 1)
    calculateCostPrice(dataCopy)
    setModalDeleteIngredient(false)
  }

  function handleChange(e) {
    var dataCopy = { ...data }
    dataCopy[e.target.name] = e.target.value

    calculateCostPrice(dataCopy)
  }

  async function fileUpload(e) {
    const file = e.target.files[0];

    if (file) {
      const imgSize = file.size / (1024 * 1024);

      if (imgSize > 25) { // Проверка, если размер больше 25 МБ
        toast.error("Размер файла не должен превышать 25 МБ.");
        return;
      }

      // Используем промис для обработки загрузки изображения
      const validateImage = () => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
              // const imgWidth = img.width;
              // const imgHeight = img.height;

              // if (imgWidth < 800 || imgHeight < 600) {
              // 	reject(new Error("Минимальный размер 800x600 px"));
              // } else {
              // resolve();
              // }
              resolve();
            };
            img.onerror = () => reject(new Error("Failed to load image"));
            img.src = event.target.result;
          };
          reader.onerror = () => reject(new Error("Failed to read file"));
          reader.readAsDataURL(file);
        });
      };

      try {
        // Ждем завершения валидации изображения
        await validateImage();

        // Если прошла валидация, формируем данные и отправляем запрос
        let formData = new FormData();
        if (data.id) formData.append("id", data.id);
        formData.append("image", file);
        formData.append("db_name", 'products');
        formData.append("column_name", 'image');
        formData.append("path", 'products');

        let response;
        if (!data.id) {
          response = await FILE('/upload-image', formData, {}, { loader: true });
        } else {
          response = await FILE(`/update-image`, formData, {}, { loader: true });
        }

        if (httpOk(response)) {
          setData({ ...data, image: response.data.url });
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
  }

  function calculateCostPrice(dataCopyFromDelete) {
    //debugger
    var dataCopy = { ...data }

    if (dataCopyFromDelete) {
      dataCopy = dataCopyFromDelete
    } else {
      dataCopy = { ...data }
    }

    if (dataCopy?.ingredients?.length) {
      dataCopy['cost_price'] = 0;
    }

    dataCopy['overall_weight_gross'] = 0
    dataCopy['overall_weight_net'] = 0
    dataCopy['overall_weight_finished'] = 0
    for (let i = 0; i < dataCopy?.ingredients?.length; i++) {
      if (!dataCopy.ingredients[i]['quantity']) {
        dataCopy.ingredients[i]['quantity'] = ''
      }

      if (dataCopy.ingredients[i]['weight_gross']) {
        dataCopy['overall_weight_gross'] += Number(dataCopy.ingredients[i]['weight_gross'])
      }

      if (dataCopy.ingredients[i]['weight_net']) {
        dataCopy['overall_weight_net'] += Number(dataCopy.ingredients[i]['weight_net'])
      }

      if (dataCopy.ingredients[i]['weight_finished']) {
        dataCopy['overall_weight_finished'] += Number(dataCopy.ingredients[i]['weight_finished'])
      }

      dataCopy['cost_price'] =
        dataCopy['cost_price'] +
        Number(dataCopy.ingredients[i]['average_price']) *
        Number(dataCopy.ingredients[i]['quantity'])

      dataCopy.ingredients[i]['cost_price'] =
        Number(dataCopy.ingredients[i]['average_price']) *
        Number(dataCopy.ingredients[i]['quantity'])
    }

    setData(dataCopy)
  }

  function addUnits() {
    var dataCopy = { ...data }

    if (!dataCopy.units) dataCopy.units = []
    dataCopy.units.push({
      'name': '',
      'quantity': '',
    })

    setData(dataCopy)
  }

  function handleChangeUnit(e, index) {
    var dataCopy = { ...data }

    dataCopy.units[index][e.target.name] = e.target.value
    if (e.target.name === 'quantity') {
      dataCopy.units[index][e.target.name] = e.target.value.replace(/[^0-9.]/g, '')
    }
    setData(dataCopy)
  }

  function deleteUnit(index) {
    var dataCopy = { ...data }
    dataCopy.units.splice(index, 1)

    setData(dataCopy)
  }

  function handleActiveTab(value) {
    setActiveTab(value)
  }

  async function selectCategory(option) {
    setIsOpen(!isOpen)
    setData({ ...data, 'category_id': option?.id, 'category_name': option?.name, })
  }

  async function getData() {
    var response = await GET(`/products/${id}`, {}, { loader: true })
    if (httpOk(response)) {
      response = response.data
      setData(response)
      var responseUnits = await GET('/helper/units')
      if (httpOk(responseUnits)) {
        setUnits(responseUnits.data)
      }

      for (let i = 0; i < response?.ingredients?.length; i++) {
        if (response.ingredients[i]['second_unit_quantity']) {
          if (response.ingredients[i]['loss'] && !response.ingredients[i]['id']) {
            response.ingredients[i]['quantity'] =
              response.ingredients[i]['second_unit_quantity'] -
              response.ingredients[i]['loss']
          }
        }
      }

      if (response) calculateCostPrice(response)
    }
  }

  async function getUnits() {
    const response = await GET('/helper/units')
    if (httpOk(response)) setUnits(response.data)
  }

  async function getCategories() {
    var response = await GET('/helper/categories')
    response = response.data

    var arr = []
    for (let i = 0; i < response.length; i++) {
      response[i]['label'] = ` ${response[i]['name']}`
      response[i].child = false;
      if (response[i].parent_id) {
        const index = response.findIndex(x => x.id === response[i].parent_id)
        response[i].child = true;
        if (response[index]?.options && response[index]?.options?.length > 0) {
          response[index].options.push(response[i])
        } else {
          response[index].options = [response[i]]
        }
      } else {
        arr.push(response[i])
      }
    }

    setCategories(arr)
    setCategoriesInitial(response)
  }

  async function getProductTypes() {
    const response = await GET('/helper/products-types')
    // Mahsulot bo'limida "Profnastil" turi aslida shakllar uchun — "Shakl" deb ko'rsatiladi (3 til)
    if (httpOk(response)) setProductTypes(response.data.map(o =>
      (/rofnastil|рофнастил/i.test(o.name || '') ? { ...o, name: t('shape') } : o)))
  }

  async function getProductIngredients() {
    const response = await GET('/helper/product-ingredients')
    if (httpOk(response)) setIngredients(response.data)
  }

  const GroupHead = props => {
    return (
      <div style={{
        padding: '0',
        color: data.category_id === props.data.id ? '#fff' : '#535277',
        fontWeight: 'bold',
        backgroundColor: data.category_id === props.data.id ? '#2684FF' : 'transparent',
        fontSize: '1rem'
      }}
        onClick={() => selectCategory(props.data)}>
        <components.Option {...props} />
      </div>
    );
  };

  const Option = props => {
    return (
      <div style={{
        padding: props.data.child ? '0 0 0 20px' : '0',
        color: '#535277',
        fontWeight: props.data.parent_id === 0 ? 'bold' : 'normal',
        fontSize: '.9rem'
      }}>
        <components.Option {...props} />
      </div>
    );
  };

  useEffect(() => {
    if (id) getData()
    if (!id) getUnits()
    getCategories()
    getProductTypes()
    getProductIngredients()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="page-header d-flex mb-2">
        <div className="d-flex">
          <h4 className="vertical-center">
            {t('product')}
          </h4>
          <div className="vertical-center mt-1">
            <i className="uil uil-angle-double-right fz-20"></i>
          </div>
          <div className="vertical-center mt-1">
            {!id ?
              <h6>{t('create')}</h6>
              :
              <h6>{t('edit')}</h6>
            }
          </div>
          {id &&
            <Fragment>
              <div className="vertical-center mt-1">
                <i className="uil uil-angle-double-right fz-20"></i>
              </div>
              <div className="vertical-center mt-1">
                {data.pos_name}
              </div>
            </Fragment>
          }
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <form autoComplete="off">
            <div className="tabs tabs-sm mb-2">
              <ul>
                <li className={mainActiveTab === 1 ? 'active' : ''}
                  onClick={() => setMainActiveTab(1)}>
                  <span className="link">{t('main')}</span>
                </li>
                <li className={mainActiveTab === 2 ? 'active ' : ''}
                  onClick={() => setMainActiveTab(2)}>
                  <span className="link">{t('ingredients')}</span>
                </li>
              </ul>
            </div>
            <div className={`row mb-5 ${mainActiveTab === 1 ? '' : 'd-none'}`}>
              <div className="col-md-5">
                <div className="flex-gap10 mb-2">
                  <div className="con-upload">
                    <div className="con-img-upload">
                      {data.image &&
                        <div className="img-upload">
                          <button type="button" className="btn-x-file" onClick={() => setData({ ...data, 'image': '' })}>
                            <i className="uil-times"></i>
                          </button>
                          <img src={`${uploadUrl}/products/${data.image}`}
                            style={{ maxWidth: 'none', maxHeight: '100%' }} alt={data.image} />
                        </div>
                      }
                      {!data.image &&
                        <div className="con-input-upload">
                          <input type="file" accept=".png, .jpg, .jpeg" onChange={(e) => fileUpload(e)} />
                          <span className="text-input fz14">
                            {t('image2')}
                          </span>
                        </div>
                      }
                    </div>
                  </div>

                  <div className="w-100">
                    <div className="form-group">
                      <label>{t("name2")}<span className="required-mark">*</span></label>
                      <div>
                        <input type="text" className="form-control" name="name" autoFocus
                          value={data.name ?? ''}
                          onChange={(e) => setData({ ...data, 'name': e.target.value })} />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>{t('type')}<span className="required-mark">*</span></label>
                      <Select
                        isDisabled={data.id}
                        options={productTypes}
                        value={productTypes.find(option => option.id === data.product_type)}
                        onChange={(option) => handleSelectInProduct(option)}
                        placeholder=""
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                      />
                    </div>

                    <div className="form-group">
                      <label>{t('unit')}<span className="required-mark">*</span></label>
                      <Select
                        options={units}
                        value={units.find(option => option.id === data.unit_id)}
                        onChange={(option) => setData({ ...data, 'unit_id': option.id })}
                        placeholder=""
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                      />
                    </div>

                    <div className="form-group w-100">
                      <label>{t('category')}</label>
                      <Select
                        components={{ GroupHeading: GroupHead, Option }}
                        isClearable
                        // isSearchable={false}
                        onMenuOpen={() => setIsOpen(true)}
                        onMenuClose={() => setIsOpen(false)}
                        onBlur={() => setIsOpen(false)}
                        menuIsOpen={isOpen}
                        classNamePrefix='react-select'
                        options={categories}
                        value={categoriesInitial.find(option => option.id === data.category_id)}
                        onChange={(option) => selectCategory(option)}
                        placeholder={t('categories')}
                        noOptionsMessage={() => t('list_empty')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                      />
                    </div>
                  </div>

                </div>

                <div className="flex-gap10">
                  <div className="form-group w-100">
                    <label>{t('length')}<span className="required-mark">*</span></label>
                    <input type="number" className="form-control" name="length"
                      disabled={!(data.product_type === 3 || data.product_type === 5)}
                      value={data.length ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  <div className="form-group w-100">
                    <label>{t('width')}<span className="required-mark">*</span></label>
                    <input type="number" className="form-control" name="width"
                      disabled={!(data.product_type === 3 || data.product_type === 5)}
                      value={data.width ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  <div className="form-group w-100">
                    <label>{t('markup')}<span className="required-mark">*</span></label>
                    <input type="number" className="form-control" name="markup"
                      // disabled={!(data.product_type === 3 || data.product_type === 5)}
                      value={data.markup ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  <div className="form-group w-100">
                    <label>{t('percentage')}<span className="required-mark">*</span></label>
                    <input type="number" className="form-control" name="percentage"
                      disabled={!(data.product_type === 4)}
                      value={data.percentage ?? ''}
                      onChange={(e) => handleChange(e)} />
                  </div>
                  {data.product_type === 4 && (
                    <div className="form-group w-100">
                      <label>{t('speed_per_min')}</label>
                      <input type="number" step="0.01" className="form-control" name="speed_per_min"
                        value={data.speed_per_min ?? ''}
                        onChange={(e) => handleChange(e)}
                        placeholder="1 daqiqada necha metr" />
                    </div>
                  )}
                </div>

                {/* <div className="flex-gap10"> n
									<div className="form-group w-100">
										<label>{t('price')}<span className="required-mark">*</span></label>
										<input type="number" className="form-control" name="price"
											value={data.price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
									<div className="form-group w-100">
										<label>{t('wholesale_price')}<span className="required-mark">*</span></label>
										<input type="number" className="form-control" name="wholesale_price"
											value={data.wholesale_price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
									<div className="form-group w-100">
										<label>{t('sale_price')}<span className="required-mark">*</span></label>
										<input type="number" className="form-control" name="sale_price"
											value={data.sale_price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
								</div> */}

                <div className="form-group w-100">
                  <label>{t("description")}</label>
                  <textarea className="form-control" name="description"
                    value={data.description ?? ''}
                    onChange={(e) => setData({ ...data, 'description': e.target.value })} />
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <p className="fw-600 vertical-center">{t('on_sale')}</p>
                  <div className="form-check form-switch form-switch-lg">
                    <input type="checkbox" className="form-check-input" name="status"
                      checked={data?.status}
                      onChange={(e) => setData({ ...data, 'status': e.target.checked })}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <div className="tabs tabs-sm">
                  <ul>
                    <li className={activeTab === 1 ? 'active ' : ''}
                      onClick={() => handleActiveTab(1)}>
                      <span className={`link ${(data.product_type === 2 || data.product_type === 3) && 'disabled'}`}>
                        {t('packaging')}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className={activeTab !== 1 ? 'd-none' : ''}>
                  <div className="table-responsive" >
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th style={{ 'width': '50%' }}>{t('name2')}</th>
                          <th style={{ 'width': '50%' }}>{t('quantity')}</th>
                          <th style={{ 'minWidth': '33px' }}>
                            <div className="table-action-button table-action-primary-button"
                              onClick={() => addUnits()}>
                              <i className="uil-plus"></i>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.units?.map((item, index) => (
                          <tr key={index}>
                            <td className="td-input">
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                placeholder=""
                                value={item.name ?? ''}
                                onChange={(e) => handleChangeUnit(e, index)} />
                            </td>
                            <td className="td-input">
                              <input
                                type="text"
                                name="quantity"
                                className="form-control"
                                placeholder="0"
                                value={item.quantity ?? ''}
                                onChange={(e) => handleChangeUnit(e, index)} />
                            </td>
                            <td className="vertical-middle">
                              {!item.id &&
                                <div className="d-flex justify-content-center">
                                  <div className="table-action-button table-action-danger-button"
                                    onClick={() => deleteUnit(index)}>
                                    <i className="uil uil-times"></i>
                                  </div>
                                </div>
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className={mainActiveTab === 2 ? '' : 'd-none'}>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ 'minWidth': '33px' }} className="text-center">#</th>
                      <th style={{ 'width': '40%' }}>{t("name2")}</th>
                      <th style={{ 'width': '15%' }}>{t("type")}</th>
                      <th style={{ 'width': '10%' }} className="text-nowrap">{t("unit")}</th>
                      <th style={{ 'width': '20%' }} className="text-end">{t("quantity")}</th>
                      <th style={{ 'width': '20%' }} className="text-nowrap text-end">{t("cost_price")}</th>
                      <th style={{ 'minWidth': '33px' }} className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.ingredients?.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center" title={item?.id ?? null}>{index + 1}</td>
                        {(id && item.id) ?
                          <td>
                            <div title={formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}>{item.name}</div>
                          </td>
                          :
                          <td className="p-0">
                            <div className="position-relative">
                              <Select
                                classNamePrefix="border-none bs-none"
                                options={ingredients}
                                value={ingredients.find(option => option.element_id === item.element_id)}
                                onChange={(option) => handleChangeIngridientSelect(index, option)}
                                placeholder=""
                                noOptionsMessage={() => t('list_empty')}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.element_id}
                                openMenuOnFocus={true}
                              />
                              {/* <i className="uil-ellipsis-h custom-select-btn"
														onClick={() => setModalSelectProduct({ 'show': true, 'index': index, 'key': 'product_id' })} /> */}
                            </div>
                          </td>
                        }
                        <td>{/rofnastil|рофнастил/i.test(item.product_type_name || '') ? t('shape') : item.product_type_name}</td>
                        <td>{item.second_unit_id ? item.second_unit_name : item.unit_name}</td>
                        <td className="td-input" style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}>
                          <input type="number" className="form-control text-end" name="quantity"
                            disabled={item.id}
                            placeholder="0"
                            value={item.quantity ?? ''}
                            onChange={(e) => handleIngridientChange(e, index)} />
                        </td>
                        <td className="td-input" style={!item.cost_price ? { 'borderBottom': '2px solid red' } : {}}>
                          <input type="number" className="form-control text-end" name="cost_price"
                            disabled={item.id}
                            placeholder="0"
                            value={item.cost_price ?? ''}
                            onChange={(e) => handleIngridientChange(e, index)} />
                        </td>
                        <td className="vertical-middle">
                          <div className="d-flex justify-content-center gap-1">
                            <div className="table-action-button table-action-danger-button"
                              onClick={() => toggleModalDeleteIngredient(item, index)}>
                              <i className="uil-times"></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td></td>
                      <td colSpan={1} style={{ 'padding': 0 }}>
                        <div className="d-flex w-100">
                          <button type="button" className="btn-sm btn-primary w-100"
                            onClick={() => addIngredients()}>
                            {t('add')}
                          </button>
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td colSpan={1} style={{ 'padding': 0 }}>
                        {/* {id &&
													<div className="d-flex w-100">
														<button type="button" className="btn-sm btn-primary w-100"
															onClick={() => toggleModalIngredientsHistory(true)}>
															<i className="uil-list-ui-alt"></i>
														</button>
													</div>
												} */}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <div className="btn-wrapper gap-2">
              <Link className="btn btn-warning btn-rounded btn-wide" to="/products">
                {t('cancel')}
              </Link>
              {!data.id &&
                <button type="button" className="btn btn-secondary btn-rounded btn-wide"
                  onClick={(e) => createUpdate(e, true)}>
                  {t('save')}
                  <i className="uil uil-arrow-right"></i>
                </button>
              }
              <button type="button" className="btn btn-primary btn-rounded btn-wide"
                onClick={(e) => createUpdate(e)}>
                {t('save')}
              </button>
            </div>
          </form>
        </div>
      </div>

      <DeleteModal
        modalDelete={modalDeleteIngredient}
        setModalDelete={setModalDeleteIngredient}
        deleteItem={deleteIngredient}>
      </DeleteModal>
    </>
  )
}

export default CreateUpdate